import { Component, input } from '@angular/core';
import type { I18nLanguageRecord } from '@onyx/angular';
import { OnyxLanguagePipe } from '@onyx/angular';

@Component({
  selector: 'app-language-cell',
  imports: [OnyxLanguagePipe],
  templateUrl: './language-cell.component.html',
  styleUrl: './language-cell.component.scss',
})
export class LanguageCellComponent {
  public readonly value = input.required<I18nLanguageRecord<any> | null>();
}
